// src/components/HuntCompleteScreen.jsx
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { getProgress, saveProgress } from '../utils/offline'
import ChickenExplosion from './ChickenExplosion'

/**
 * End screen for proximity hunts, which have no final word puzzle: reaching the
 * last treasure is the finish line. Mirrors the solved state of PuzzleScreen.
 * @param {string} hint - Final hint to show
 * @param {Function} onComplete - Callback when the hunt is marked complete
 * @param {boolean} initialCompleted - Skip the animation (already completed)
 */
export default function HuntCompleteScreen({ hint, onComplete, initialCompleted = false }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [completed, setCompleted] = useState(initialCompleted)
  const [showAnimation, setShowAnimation] = useState(!initialCompleted)

  function handleReset() {
    setCompleted(false)

    getProgress().then(async (prog) => {
      await saveProgress({
        ...prog,
        puzzleCompleted: false,
        puzzleCompletedAt: null,
        foundTreasures: []
      })
    }).catch(err => console.error('Failed to reset progress:', err))

    navigate('/')
  }

  return (
    <>
      {showAnimation && (
        <ChickenExplosion
          onAnimationComplete={() => {
            setShowAnimation(false)
            setCompleted(true)
            onComplete()
          }}
        />
      )}
      {completed && (
        <div style={styles.container}>
          <h1 style={{ color: '#28a745', marginBottom: '20px' }}>{t('proximity.huntComplete')}</h1>
          <p style={{ fontSize: '18px', lineHeight: '1.6', marginBottom: '30px' }}>
            <strong>{t('puzzle.finalHint')}</strong>
          </p>
          <p style={{
            fontSize: '24px',
            fontWeight: 'bold',
            color: '#FF6B6B',
            padding: '20px',
            background: '#FFF3E0',
            borderRadius: '8px',
            textAlign: 'center',
            marginBottom: '30px'
          }}>
            {hint}
          </p>
          <button
            onClick={handleReset}
            style={styles.actionButton}
          >
            {t('puzzle.startOver')}
          </button>
        </div>
      )}
    </>
  )
}

const styles = {
  container: {
    maxWidth: '500px',
    margin: '0 auto',
    padding: '30px 20px',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  actionButton: {
    padding: '15px 30px',
    background: '#28a745',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer'
  }
}
